import styles from "./sliderMob.module.css";
import { useEffect, useRef, useState } from "react";
import Icon from "./../../icons/icon";

const SliderMob = ({ instantScroll, instantScrollUp, data }) => {
  const [index, setIndex] = useState(-1);
  const [showNav, setShowNav] = useState(false);

  const sectionRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth > 650) return;

    const scrollEvent = () => {
      if (
        sectionRef.current.getBoundingClientRect().top < 100 &&
        sectionRef.current.getBoundingClientRect().top * -1 <
          sectionRef.current.getBoundingClientRect().height - window.innerHeight
      ) {
        setShowNav(true);
      } else {
        setShowNav(false);
      }
    };

    window.addEventListener("scroll", scrollEvent);

    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, []);

  return (
    <div className={styles.sliderSection} ref={sectionRef}>
      {data.map((item, itemIndex) => (
        <Item
          setIndex={setIndex}
          key={itemIndex}
          item={item}
          index={itemIndex}
        />
      ))}

      <div
        className={styles.nav}
        style={{
          transform: showNav ? "translateY(0px)" : "translateY(200px)",
          opacity: showNav ? 1 : 0,
        }}
      >
        <div className={styles.counter}>
          <div>{index + 1}</div> / <div>{data.length}</div>
        </div>
        <div className={styles.scrollBtn}>
          <div className={styles.up} onClick={instantScrollUp}>
            <Icon type="Chevron" />
          </div>
          <div className={styles.down} onClick={instantScroll}>
            <Icon type="Chevron" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderMob;

const Item = ({ item, index, setIndex }) => {
  const [opacity, setOpacity] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const { top } = sectionRef.current.getBoundingClientRect();

      if (top < window.innerHeight && top > 0) {
        setIndex(index);
      }

      let opacity;

      if (top > 0) {
        opacity = Math.max(
          0,
          Math.min(1, (window.innerHeight - top) / window.innerHeight)
        );
      } else {
        opacity = (top + window.innerHeight + 0.1) / window.innerHeight;
      }

      setOpacity(opacity);
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const sectionRef = useRef(null);

  return (
    <div
      className={styles.sliderWrapper}
      id="section2"
      style={{ opacity }}
      ref={sectionRef}
    >
      <div className={`${styles.sliderContainer}`}>
        <div className={`${styles.top} narrow-container`}>
          <div className={styles.item} style={{}}>
            <h2>
              {item.title.map((title) => (
                <>
                  {title} <br />
                </>
              ))}
            </h2>
            <p>{item.text}</p>
          </div>
        </div>

        <div className={styles.overlay}></div>

        <div className={styles.images}>
          <img
            src={process.env.PUBLIC_URL + `/json/sliderImage/${item?.image}`}
            fill
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
